export enum ApiRoutesSupportTickets {
  Tickets = "admin/support-tickets",
}

export const SUPPORT_TICKETS_QUERY_KEY = "support-tickets";
